export default __webpack_public_path__ + "static/media/NanumSquareB.ebe0aa17.ttf";